import FlightStatus from '@/store/data/enums/FlightStatuses'

export default [
	{

		label: 'flights.status.taken',
		value: FlightStatus.taken
	},
	{
		label: 'flights.status.notTaken',
		value: FlightStatus.notTaken
	},
	{
		label: 'flights.status.cancelled',
		value: FlightStatus.cancelled
	}
]
